module.exports = __webpack_public_path__ + "img/talk.7fdfefe0.svg";